var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-5 md:mb-10 text-center px-8" }, [
    _c(
      "div",
      {
        staticClass:
          "\n      rounded-full\n      w-25\n      h-25\n      flex\n      items-center\n      justify-center\n      mx-auto\n      mb-4\n    "
      },
      [
        _c("img", {
          staticClass: "flex-shrink-0",
          attrs: { alt: "Image decoration", src: _vm.imgSrc }
        })
      ]
    ),
    _vm._v(" "),
    _c("h2", { staticClass: "last:mb-0 md:text-4xl" }, [_vm._t("header")], 2),
    _vm._v(" "),
    _vm.$slots.body
      ? _c(
          "div",
          {
            staticClass:
              "text-editor font-normal text-base md:text-2xl lg:w-2/3 lg:px-10 mx-auto lg:leading-10 lg:-mt-2.5"
          },
          [_vm._t("body")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }